module.exports = new __parcel__URL__("Archerskill_26.f12ea740.png").toString();